// extracted by mini-css-extract-plugin
export default {"news_container":"News_news_container__4Qplj","news_content":"News_news_content__Wvjag","swiper":"News_swiper__QUeXZ"};